export default __webpack_public_path__ + "static/media/safeBlack.3b1ec451.svg";